<template>
  <!-- <div class="block" style="height: 7.5rem;"> -->
  <span class="block">
        <!-- <el-row> -->
    <el-select v-model="dataValue" placeholder="请选择" clearable @change="selecDate" class="selectWord">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item"
        >
      </el-option>
    </el-select>
        <!-- </el-row>
        <el-row> -->
      <el-date-picker
      class="date-picker"
      v-model="bindValue"
      value-format="yyyy-MM"
      format="yyyy-MM"
      @change="dataSearch"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      v-if="hackReset" style="margin-left: 0px;">
    </el-date-picker>
        <!-- </el-row> -->
	</span>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bindValue:[],
      radio: 0,
      options: [{
        value: '最近一月',
        label: '最近一月'
      }, {
        value: '最近三月',
        label: '最近三月'
      }, {
        value: '最近半年',
        label: '最近半年'
      }, {
        value: '最近一年',
        label: '最近一年'
      }],
      dataValue: '',
      hackReset: true,
      selectValue: [],
    };
  },
  watch:{
    "value": function(val) {
      this.bindValue = val
    },
  },
  filters: {
    timestampToTime(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      // var D = (date.getDate()<10?'0'+(date.getDate()):date.getDate()) + ' ';
      // var h = (date.getHours()<10?'0'+(date.getHours()):date.getHours())+ ':';
      // var m = (date.getMinutes()<10?'0'+(date.getMinutes()):date.getMinutes()) + ':';
      // var s = (date.getSeconds()<10?'0'+(date.getSeconds()):date.getSeconds());
      return Y + M;
    }
  },
  methods: {
    //获取选中日期的值
    dataSearch(value) {
      this.$emit('dataSearch', value )
    },
    //快速定位日期
    selecDate(item){
      var endTe = this.$options.filters['timestampToTime'];
      this.dataValue = item.value
      const end = new Date()
      var start = new Date();
      var newStart = '';
      var newEnd = '';
      newEnd = endTe(end)
      if(item.value == '最近一月') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        newStart = endTe(start)
        this.hackReset = false
      }else if(item.value == '最近三月'){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        newStart = endTe(start)
        this.hackReset = false
      }else if(item.value == '最近半年'){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        newStart = endTe(start)
        this.hackReset = false
      }else if(item.value == '最近一年'){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        newStart = endTe(start)
        this.hackReset = false
      }
      this.$set(this.bindValue, "0", newStart)
      this.$set(this.bindValue, "1", newEnd)
      this.$emit('dataSearch', this.bindValue )
      this.$nextTick(() => {
        this.hackReset = true
        this.$emit('pick', [newStart, newEnd]);
      });
    }
  },
  mounted() {
		var endTe = this.$options.filters['timestampToTime'];
		var start = new Date();
		const end = new Date()
		var newStart = '';
		var newEnd = '';
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
		newStart = endTe(start)
		newEnd = endTe(end)
		this.dataValue = '最近一年';
		this.bindValue.push(newStart);
		this.$emit('dataSearch', this.bindValue )
		this.bindValue.push(newEnd);
		// console.log(this.bindValue)
  }
};
</script>
<style scoped lang="stylus">
  .date-picker
    margin-left: 10px
    width: 250px
  .selectWord
    width: 120px
  .block
    height: 36px
  /deep/.el-date-editor .el-range-separator
    line-height: 28px
</style>